import { Injectable } from '@angular/core';
import { INGXLoggerConfig, INGXLoggerMetadata, NgxLoggerLevel, NGXLoggerWriterService } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class LoggerWriterService extends NGXLoggerWriterService {
 protected prepareMetaString(metadata: INGXLoggerMetadata, config: INGXLoggerConfig): string {
    const fileName = metadata.fileName?.charAt(0) === '.' ? 'webpack://' + metadata.fileName?.substring(1) : metadata.fileName;
    // metadata.message=`${metadata.fileName}:L${metadata.lineNumber},C${metadata.columnNumber} ${metadata.message}` ;
    return super.prepareMetaString({ ...metadata, fileName }, config);
  }
}
